<template>
  <v-row
    class="elevation-1 my-2 rounded-sm white"
  >
    <v-col cols="12" md="6">
      <div><b>{{ product.product_name }}</b></div>
      <div><b>ID: {{ product.product_id }}</b></div>
      <div class="text-body-2">
        <div>{{ product.address[0].full_address }}</div>
        <div>{{ product.term.term_label }}</div>
      </div>
    </v-col>

    <v-col cols="12" md="6" align-self="center">
      <v-row>
        <v-col
          cols="12"
          md="4"
          order="2"
          order-md="1"
          align-self="center"
        >
          <div :class="`font-italic float-right ${formStatus.color}--text`">
            {{ formStatus.description }}
          </div>
        </v-col>
        <v-col v-if="product.order_web_type.type !== 'renew'" cols="12" md="8" order="1" order-md="2" align-self="center">
          <v-btn class="white--text" :color="buttonColor" :dark="product.form_status === 'completed'"
            @click="setProductSelected(product.product_id)" v-if="hasTabs" block>
            {{ formStatus.action }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ProductFormStarter',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    if (this.getFormData[this.product.product_id]?.product_status) {
      this.status = this.getFormData[this.product.product_id].product_status;
    }
  },
  methods: {
    ...mapActions(['setCurrentProductId', 'updateStoreFormData']),
    setProductSelected(productId) {
      this.setCurrentProductId(productId);
      const product = this.getProductInfo();
      if (product.product_status !== 'completed') {
        this.updateStoreFormData({
          data: 'in_progress',
          main: productId,
          sub: 'product_status',
        });
      }
    },
  },
  computed: {
    hasTabs() {
      if (this.productSubTabs(this.product).length < 1) {
        return false;
      }

      return true;
    },
    buttonColor() {
      if (this.product.form_status === 'completed') {
        return 'blue-grey';
      }
      return 'third';
    },
    formStatus() {
      if (this.product.order_web_type.type === 'renew') {
        return {
          description: 'Completed',
          color: 'second',
          action: 'Edit',
        };
      }

      if (this.productSubTabs(this.product).length === 0) {
        return this.formStatuses.completed;
      }

      return this.formStatuses[this.status || 'not_started'];
    },
    ...mapGetters(['getProductInfo', 'getFormData', 'productSubTabs']),
  },
  data() {
    return {
      formStatuses: {
        completed: {
          description: 'Completed',
          color: 'second',
          action: 'Edit',
        },
        in_progress: {
          description: 'In progress',
          color: 'third',
          action: 'Continue',
        },
        not_started: {
          description: 'Not started',
          color: 'first',
          action: 'Start',
        },
      },
      status: 'not_started',
    };
  },
};
</script>
